var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.666,
    height: 20.665,
    viewBox: "0 0 20.666 20.665",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_104458_facebook_social_media_fb_social_icon_1_",
    "data-name": "104458_facebook_social media_fb_social_icon (1)",
    d: "M14.055,5.157A10.333,10.333,0,1,0,24.388,15.49,10.333,10.333,0,0,0,14.055,5.157Zm2.735,10.29H15v6.381H12.348V15.447H11.087V13.194h1.261v-1.46a2.487,2.487,0,0,1,2.677-2.676l1.964.008v2.188H15.563a.539.539,0,0,0-.562.613v1.327h2.022Z",
    transform: "translate(-3.722 -5.157)",
    fill: "#7f6bf6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbBlue);
export default __webpack_public_path__ + "static/media/fb_blue.df88b163c7bf1a21102808009b1e8eb8.svg";
export { ForwardRef as ReactComponent };